import { fetchQuery, graphql } from "react-relay"
import { fetchExistingChPrescriptionQuery } from "@/modules/patients/detail/prescription/ch/services/__generated__/fetchExistingChPrescriptionQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const existingChPrescriptionQuery = graphql`
  query fetchExistingChPrescriptionQuery($progressNoteId: ID!) {
    ch_progressNoteById(id: $progressNoteId) {
      ch_prescription {
        id
        ...chPrescriptionFragment
      }
    }
  }
`

export const fetchExistingChPrescription = (progressNoteId: string) =>
  fetchQuery<fetchExistingChPrescriptionQuery>(RelayEnvironment, existingChPrescriptionQuery, {
    progressNoteId,
  }).toPromise()
